import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CoachingService} from '../service/coaching.service';
import {CoachingReportModel} from '../model/coaching-report.model';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation, fadeInUpOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {Subscription} from 'rxjs';
import {EventsService} from '../../../services/events.service';
import {IonSlides, NavController} from '@ionic/angular';
import {UserService} from '../../../services/user.service';
import {CoachingSummaryModel} from '../model/coaching-summary.model';
import {AnalyticsService} from '../../../services/analytics.service';

@Component({
    selector: 'app-my-coaching-report',
    templateUrl: './coaching-report.component.html',
    styleUrls: ['./coaching-report.component.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        fadeInUpOnEnterAnimation({anchor: 'enterUp', duration: 300}),
    ],
})
export class CoachingReportComponent implements OnInit, OnDestroy {

    @ViewChild(IonSlides, {static: true, read: IonSlides}) slides: IonSlides;

    subscriptions: Subscription[] = [];

    coachingList: CoachingSummaryModel = null;

    coachingId = 0;
    delegateId = 0;
    level = 'learner';

    slidesTotal = 0;
    slideCurrent = -1;

    reportDate: string = null;

    // Optional parameters to pass to the swiper instance.
    // See http://idangero.us/swiper/api/ for valid options.
    slideOpts = {
        shortSwipes: false
    };

    constructor(
        private event: EventsService,
        private analytics: AnalyticsService,
        private coachingService: CoachingService,
        private activatedRoute: ActivatedRoute,
        public userService: UserService,
        private navCtrl: NavController,
        private router: Router
    ) {
        this.level = this.activatedRoute.snapshot.data.level;
        if (this.level === 'manager') {
            this.delegateId = Number(this.activatedRoute.snapshot.paramMap.get('delegateId'));
        } else {
            this.delegateId = this.userService.getCurrentUserInfo().id;
        }
        this.coachingId = Number(this.activatedRoute.snapshot.paramMap.get('coachingId'));
        if (this.coachingId === 0) {
            this.goBack();
        }

        this.subscriptions.push(
            this.event.subscribe('coaching:getCoachingReport', (coaching: CoachingReportModel) => {
                if (this.coachingList !== null) {
                    this.coachingList.reports.details.forEach((item) => {
                        if (item.id === coaching.id) {
                            item.date = coaching.date;
                            item.coachee_name = coaching.coachee_name;
                            this.setReportDate();
                        }
                    });
                }
            })
        );
    }

    ngOnInit() {
        if (this.level === 'manager') {
            this.coachingService.getUserCoachingSummary(this.delegateId)
                .then(data => {
                    this.coachingList = data;
                    this.initSlides();
                });
        } else {
            this.coachingService.getMyCoachingSummary()
                .then(data => {
                    this.coachingList = data;
                    this.initSlides();
                });
        }
    }

    ionViewDidEnter() {
        if (this.level === 'manager') {
            this.analytics.trackView('Coaching Report');
        } else {
            this.analytics.trackView('My Coaching Report');
        }
    }

    initSlides() {
        this.slidesTotal = this.coachingList.reports.details.length;
        this.slideCurrent = this.coachingList.reports.details.findIndex((item) => item.id === this.coachingId);
        this.slides.slideTo(this.slideCurrent);
        this.setReportDate();

        this.analytics.trackEvent('coaching_view', {
            coaching_id: this.coachingList.reports.details[this.slideCurrent].id.toString(),
        });
    }

    slideChanged(event) {
        this.slides.getActiveIndex().then((index) => {
            this.slideCurrent = index;
            this.setReportDate();
        });
    }

    setReportDate() {
        this.reportDate = null;
        setTimeout(() => {
            this.reportDate = this.coachingList.reports.details[this.slideCurrent].date.output.long;
        }, 300);
    }

    next() {
        this.slides.slideNext();
    }

    prev() {
        this.slides.slidePrev();
    }

    goBack() {
        this.navCtrl.back();
    }

    gotoCoachingForm() {
        this.router.navigate(['/coaching/user/form/edit/',
            this.coachingList.reports.details[this.slideCurrent].id]);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
